import { Component, Element, h, Host, Prop, State, Watch } from '@stencil/core';

import { translations } from './translations';

const SHARE_URLS = [
  { platform: 'linkedin', url: 'https://www.linkedin.com/sharing/share-offsite/?url=', text: 'LinkedIn' },
  { platform: 'twitter', url: 'https://twitter.com/intent/tweet?url=', text: 'Twitter' },
  { platform: 'facebook', url: 'https://www.facebook.com/sharer/sharer.php?u=', text: 'Facebook' },
];

@Component({
  tag: 'pn-share',
  styleUrl: 'pn-share.scss',
})
export class PnShare {
  @Element() hostElement: HTMLElement;
  @Prop() link: string = null;
  @Prop({ mutable: true, reflect: true }) language: string = 'sv';
  @State() i18n: any;

  componentWillLoad() {
    this.setTranslations();
  }

  setTranslations() {
    if (this.language === 'nb') {
      this.language = 'no';
    }
    if (this.language && translations[this.language]) {
      this.i18n = translations[this.language];
    }
  }

  @Watch('language')
  onLanguageChange() {
    this.setTranslations();
  }

  render() {
    return (
      <Host>
        <div class="pn-share__container">
          <h3 class="pn-share__heading">{this.i18n.sharelabel}:</h3>
          <div class="pn-share__items">
            {SHARE_URLS.map(platform => {
              return (
                <pn-share-item link={`${platform.url}${this.link}`} text={platform.text}>
                  <pn-icon slot="icon" icon={platform.platform}></pn-icon>
                </pn-share-item>
              );
            })}
          </div>
        </div>
      </Host>
    );
  }
}
